/**
 * Creado por Norte70
 * @author Heriberto Monterrubio <heri185403@gmail.com>
 * @Date 29/09/2020
 */
const errorResponse = () =>{
    return {
        code: null,
        error: null,
        message: null
    }
}

export default errorResponse;